import React from "react";
import "react-table-v6/react-table.css";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import {
    Icon,
    Grid,
    Button,
    Card,
    Image,
    GridColumn,
    Dropdown,
    Label,
    Modal,
    Form,
    Input,
    Dimmer,
    Loader
} from "semantic-ui-react";
import ButtonHandler from "../../ButtonHandler.jsx";
import processIcon from "../../../Images/process.png";
import excel from "../../../Images/excel_icon.png";
import CheckboxTable from "../../ControlPanelComponents/CheckboxView.jsx";
import {
    runWholeSaleAutomationScript,
    getWholeSaleAutomationScriptStatus,
    fetchTemplates,
    fetchUseraction,
    rawFileProcess,
    getWorkingFiles,
    getWholeSaleLocationsData,
    addWholeSalePeriodsData,
    getWholeSalePeriodsData,
    wholesaleSplitFiles,
    getwholesalesplitStatus,
    getwholesalesplittedFiles,
    processCreditNoteWholeSale,
    getWholesalDisbursementFormulas,
    wholesaleIpdateDisbursementFormulas,
    sendWholesaleWorkingFiles,
    sendWholesaleCreditNoteFiles,
    getApprovedEmails,
    getWholesaleWokingReleaseProcessStatus,
    downloadallDSEfiles,
    downloadallCreditNotefiles,
    sendApprovalEmailToPandG,
    getPlanData
} from '../../../actions/users_action';
import SemanticDatepicker from 'react-semantic-ui-datepickers';

var apiTimeout = null
class Wholesale extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            automationStatus: 'Pending',
            initial: true,
            outputUrl: '',
            downloadEnable: false,
            templateId: "",
            distributors: [],
            selectedDistributor: '',
            formulaModalOpen: false,
            formulas: [],
            selectedTemplate: '',
            templates: [],
            automationSplitFiles: [],
            modalOpen: false,
            fileUploaded: false,
            fileName: '',
            currentFile: {},
            workingFiles: [],
            auditingSplit: [],
            nonAuditingSplit: [],
            formulasType: '',
            loaderStatus: false,
            selectedDist: {},
            disType: 'WholeSale',
            periodModalOpen: false,
            locationList: [],
            overallLocationPeriods: [],
            splittedFiles: [],
            selectedLocation: '',
            approvalModalOpen: false,
            approvedEmailData: [],
            releaseAlertMoalOpen: false,
            creditNoteReleaseAlertModalOpen: false,
            wsPgTargetDataUrl: ''
        };
    }

    async componentDidMount() {
        await this.props.fetchTemplates({
            onSuccess: (res) => {
                this.props.getWholeSaleAutomationScriptStatus(res.templates[res.templates.length - 1]['_id'], {
                    onSuccess: (res) => {
                        if (res.master.fileUploadStatus) {
                            if (res.master.fileUploadStatus == 'Completed') {
                                console.log(res.master, 'res')
                                this.setState({ automationStatus: res.master.fileUploadStatus, downloadEnable: true, outputUrl: res.master.finalOutputUrl, initial: false })
                                // clearTimeout(apiTimeout)
                            }
                            else if (res.master.fileUploadStatus == 'Failed') {
                                this.setState({ automationStatus: res.master.fileUploadStatus, initial: false })
                                // clearTimeout(apiTimeout)
                            }
                        }
                    },
                    onFailure: () => {

                    }
                })


                let temp_data = {
                    templateId: res.templates[res.templates.length - 1]['_id']
                }
                this.props.getWholeSaleLocationsData(temp_data, {
                    onSuccess: (response) => {

                        this.props.getWholeSalePeriodsData(this.state.templateId, {
                            onSuccess: (res) => {
                                if (res.salesPeriodsData.length > 0) {
                                    this.setState({ locationList: res.salesPeriodsData, loaderStatus: false })
                                }
                                else {
                                    let a = this.state.selectedTemplate;
                                    let b = a.split("-")[1].replace(' ', '')
                                    let month = b.split(" ")[0]
                                    let year = b.split(" ")[1]
                                    const firstDate = new Date(`${month} 1, ${year}`);
                                    const fifteenthDate = new Date(`${month} 15, ${year}`);
                                    let location_list = []
                                    if (response.locations.length > 0) {
                                        response.locations.map((loc) => {
                                            console.log(this.formatDate(firstDate), 'date')
                                            location_list.push({
                                                'location': loc,
                                                'startDate': this.formatDate(firstDate),
                                                'endDate': this.formatDate(fifteenthDate)
                                            })
                                        })
                                    }
                                    this.setState({ locationList: location_list, loaderStatus: false })

                                }
                            },
                            onFailure: () => {

                            }
                        })


                    },
                    onFailure: () => {

                    }
                })




                this.setState({ templates: res.templates, selectedTemplate: res.templates[res.templates.length - 1]['name'], templateId: res.templates[res.templates.length - 1]['_id'], fileTemplates: res.templates[res.templates.length - 1]['fileTemplates'] })
            },
            onFailure: () => {
            }
        })

    }

    start = () => {
        this.setState({
            automationStatus: 'Processing',
            initial: false
        })

        let data = {
            templateId: this.state.templateId
        }

        this.props.runWholeSaleAutomationScript(data, {
            onSuccess: () => {
                apiTimeout = setTimeout(this.loadData, 3000)
            },
            onFailure: () => {

            }
        })
    }

    loadData = () => {
        this.props.getWholeSaleAutomationScriptStatus(this.state.templateId, {
            onSuccess: (res) => {
                if (res.master.fileUploadStatus) {
                    if (res.master.fileUploadStatus == 'Completed') {
                        this.setState({ automationStatus: res.master.fileUploadStatus, downloadEnable: true, outputUrl: res.master.finalOutputUrl })
                        clearTimeout(apiTimeout)
                    }
                    else if (res.master.fileUploadStatus == 'Failed') {
                        this.setState({ automationStatus: res.master.fileUploadStatus, initial: false })
                        clearTimeout(apiTimeout)
                    }
                }
            },
            onFailure: () => {

            }
        })
        apiTimeout = setTimeout(this.loadData, 3000)
    }

    downloadfile = (url) => {
        window.open(url);
    }

    dropDownDistributorOnChange = (e, data) => {
        this.setState({ selectedDistributor: data.value })
    }

    formatDate = (date) => {
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        return `${dd}-${mm}-${yyyy}`;
    };


    dropDownTemplateOnChange = async (e, data) => {

        data.options.map(async (d) => {
            if (d.value == data.value) {
                this.setState({ templateId: d.key, loaderStatus: true })
                await this.props.fetchUseraction(
                    d.key,
                    {
                        onSuccess: (res) => {
                            this.setState({ distributors: res.users })
                        },
                        onFailure: () => { this.setState({ loading: false }) }
                    });

                await this.props.getWholeSaleAutomationScriptStatus(d.key, {
                    onSuccess: (res) => {
                        if (res.master.fileUploadStatus) {
                            if (res.master.fileUploadStatus == 'Completed') {
                                console.log(res.master, 'res')
                                this.setState({ automationStatus: res.master.fileUploadStatus, downloadEnable: true, outputUrl: res.master.finalOutputUrl, initial: false })
                                // clearTimeout(apiTimeout)
                            }
                            else if (res.master.fileUploadStatus == 'Failed') {
                                this.setState({ automationStatus: res.master.fileUploadStatus, downloadEnable: false, initial: false })

                            }
                        }
                    },
                    onFailure: () => {

                    }
                })

                await this.props.getWorkingFiles(d.key, 'wholesaleDisbursement', {
                    onSuccess: (res) => {
                        console.log(res, 'response')
                        this.setState({ workingFiles: res.workingFiles })
                    },
                    onFailure: () => {

                    }
                })


                this.props.getPlanData(d.key, {
                    onSuccess: (res) => {
                        if (res.files.length > 0) {
                            res.files.map((d) => {
                                if (d.fileName == "wsPgTargetData") {
                                    this.setState({ wsPgTargetDataUrl: d.result[0] })
                                }

                            })

                        }
                        else {
                            this.setState({ templateDataUrl: '', planDataUrl: '' })
                        }
                    },
                    onFailure: () => {

                    }
                })

                await this.props.getwholesalesplittedFiles(d.key, {
                    onSuccess: (res) => {
                        this.setState({ splittedFiles: res.splittedFiles })
                    },
                    onFailure: () => {

                    }
                })

                let temp_data = {
                    templateId: d.key
                }
                await this.props.getWholeSaleLocationsData(temp_data, {
                    onSuccess: (response) => {

                        this.props.getWholeSalePeriodsData(this.state.templateId, {
                            onSuccess: (res) => {
                                if (res.salesPeriodsData.length > 0) {
                                    this.setState({ locationList: res.salesPeriodsData, loaderStatus: false })
                                }
                                else {
                                    let a = this.state.selectedTemplate;
                                    let b = a.split("-")[1].replace(' ', '')
                                    let month = b.split(" ")[0]
                                    let year = b.split(" ")[1]
                                    const firstDate = new Date(`${month} 1, ${year}`);
                                    const fifteenthDate = new Date(`${month} 15, ${year}`);
                                    let location_list = []
                                    if (response.locations.length > 0) {
                                        response.locations.map((loc) => {
                                            console.log(this.formatDate(firstDate), 'date')
                                            location_list.push({
                                                'location': loc,
                                                'startDate': this.formatDate(firstDate),
                                                'endDate': this.formatDate(fifteenthDate)
                                            })
                                        })
                                    }
                                    this.setState({ locationList: location_list, loaderStatus: false })

                                }
                            },
                            onFailure: () => {

                            }
                        })


                    },
                    onFailure: () => {

                    }
                })
                // this.setState({loaderStatus:false})

            }
            else {
                this.setState({ downloadEnable: false, initial: true, automationStatus: 'Pending', locationList: [] })
            }
        })
        this.setState({ selectedTemplate: data.value })
    }



    closeuploadoption = () => {
        this.setState({ modalOpen: false, periodModalOpen: false, approvalModalOpen: false, releaseAlertMoalOpen: false })
    }

    fileupload = (file) => {
        this.setState({ currentFile: file.target.files[0], fileUploaded: true })
    };

    uploadRawFile = () => {
        this.setState({ loaderStatus: true })
        this.props.rawFileProcess(this.state.currentFile, this.state.fileName, this.state.templateId, {
            onSuccess: () => {
                this.setState({ modalOpen: false, loaderStatus: false })
                alert("File Uploaded Successfully")
                this.props.getWorkingFiles(this.state.templateId, 'wholesaleDisbursement', {
                    onSuccess: (res) => {
                        console.log(res, 'response')
                        this.setState({ workingFiles: res.workingFiles })
                    },
                    onFailure: () => {

                    }
                })

                this.props.getPlanData(d.key, {
                    onSuccess: (res) => {
                        if (res.files.length > 0) {
                            res.files.map((d) => {
                                if (d.fileName == "wsPgTargetData") {
                                    this.setState({ wsPgTargetDataUrl: d.result[0] })
                                }

                            })

                        }
                        else {
                            this.setState({ templateDataUrl: '', planDataUrl: '' })
                        }
                    },
                    onFailure: () => {

                    }
                })


            },
            onFailure: () => {

            }
        })
    }

    uploadFile = async (fileName, type) => {
        console.log(type, 'type')
        this.setState({ fileName: fileName, fileType: type, modalOpen: true })

    }

    loadSplitData = () => {

        this.props.getwholesalesplitStatus(this.state.templateId, 'wholesaleDisbursement', {
            onSuccess: (res) => {
                if (res.master.splitStatus) {
                    if (res.master.splitStatus == 'Completed') {
                        this.setState({ loaderStatus: false })
                        clearTimeout(apiTimeout)
                        this.props.getwholesalesplittedFiles(this.state.templateId, {
                            onSuccess: (res) => {
                                this.setState({ splittedFiles: res.splittedFiles })
                            },
                            onFailure: () => {

                            }
                        })
                    }
                    else if (res.master.splitStatus == 'Failed') {
                        this.setState({ loaderStatus: false })
                        clearTimeout(apiTimeout)
                        alert('Something Wrong.Contact Admin')
                    }
                }
            },
            onFailure: () => {

            }
        })
        apiTimeout = setTimeout(this.loadSplitData, 3000)
    }


    splitFiles = async () => {

        if (this.state.splittedFiles.length > 0) {
            alert('Split Already Done')
        }
        else if (this.state.workingFiles.length == 0) {
            alert("Please Upload Approved File for further Process")
        }
        else {
            let data = {
                templateId: this.state.templateId
            }
            this.setState({ loaderStatus: true })
            await this.props.wholesaleSplitFiles(data, {
                onSuccess: () => {
                    apiTimeout = setTimeout(this.loadSplitData, 3000)
                }
            })
        }

    }

    siteData = (rowData, checkedValue) => {

        this.setState({ 'selectedDist': rowData })

    };

    sendedData = (rowData, row) => {
        this.setState({ 'selectedDist': rowData })
    };

    periodSelect = () => {

        this.setState({ periodModalOpen: true })

    }

    dropDownLocationOnChange = (e, data) => {
        this.setState({ selectedLocation: data.value })
    }

    handleStartDateChange = (e, location) => {
        let locationData = this.state.locationList
        locationData.map((loc) => {
            if (loc.location == location.location) {
                loc.startDate = e.target.value
            }
        })
        this.setState({ startDate: e.target.value, locationList: locationData })
    }

    handleEndDateChange = (e, location) => {
        let locationData = this.state.locationList
        locationData.map((loc) => {
            if (loc.location == location.location) {
                loc.endDate = e.target.value
            }
        })
        this.setState({ endDate: e.target.value, locationList: locationData })
    }

    savePeriodsData = () => {
        let data = {
            templateId: this.state.templateId,
            locationList: this.state.locationList
        }
        this.setState({ loaderStatus: true })
        this.props.addWholeSalePeriodsData(data, {
            onSuccess: (res) => {
                this.setState({ loaderStatus: false, periodModalOpen: false })
            },
            onFailure: () => {

            }
        })
    }



    formulasModal = (types) => {
        let type = {
            disType: 'Wholesale'
        }
        this.props.getWholesalDisbursementFormulas(type, {
            onSuccess: (res) => {
                console.log(res, 'res')
                let formulas_calc = res.data.formulas
                console.log(formulas_calc, 'formulas')
                this.setState({ formulas: formulas_calc })
            },
            onFailure: () => {

            }
        })
        this.setState({ formulaModalOpen: true })

    }

    formulaOnChange = (e, data) => {
        let formulas_data = this.state.formulas;
        formulas_data.map((d) => {
            if (Object.keys(d)[0] == Object.keys(data)[0]) {
                d[Object.keys(d)[0]] = e.target.value + '\n'
            }
        })
        this.setState({ formulas: formulas_data })
    }

    saveFormulas = () => {
        let data = {
            formulas: this.state.formulas,
            disType: 'Wholesale'
        }
        this.props.wholesaleIpdateDisbursementFormulas(data, {
            onSuccess: () => {
                this.setState({ formulaModalOpen: false })
                alert("Formulas File Updated")
            },
            onFailure: () => {

            }
        })
    }

    loadWoringReleaseData = () => {
        this.props.getWholesaleWokingReleaseProcessStatus(this.state.templateId, {
            onSuccess: (res) => {
                if (res.result.workingRelease) {
                    // console.log(res.result,'result check')
                    if (res.result.workingRelease == 'Completed') {
                        this.setState({ loaderStatus: false, releaseAlertMoalOpen: false })
                        clearTimeout(apiTimeout)
                        alert('Working Files Released Successfully.Please check mails')
                    }
                }
            },
            onFailure: () => {

            }
        })
        apiTimeout = setTimeout(this.loadWoringReleaseData, 3000)
    }

    releaseWorking = () => {
        if (this.state.selectedDist.length !== 0) {
            this.setState({ loaderStatus: true })

            let data = {
                selectedDist: this.state.selectedDist,
                templateId: this.state.templateId
            }

            this.props.sendWholesaleWorkingFiles(data, {
                onSuccess: () => {
                    apiTimeout = setTimeout(this.loadWoringReleaseData, 3000)
                    // this.setState({ loaderStatus: false })
                    // 
                },
                onFailure: () => {

                }
            })
        }
        else {
            alert('Please Select Distributor')
        }

    }

    loadProcessCreditNote = () => {
        this.props.getWholesaleWokingReleaseProcessStatus(this.state.templateId, {
            onSuccess: (res) => {
                if (res.result.creditNoteProcessStatus) {
                    if (res.result.creditNoteProcessStatus == 'Completed') {
                        // this.setState({ loaderStatus:false})
                        clearTimeout(apiTimeout)
                        alert('Credit Note Processed Successfully')
                        this.props.getwholesalesplittedFiles(this.state.templateId, {
                            onSuccess: (res) => {
                                this.setState({ splittedFiles: res.splittedFiles, loaderStatus: false })
                                // alert('Credit Note Process Done')
                            },
                            onFailure: () => {

                            }
                        })
                    }
                }
            },
            onFailure: () => {

            }
        })
        apiTimeout = setTimeout(this.loadProcessCreditNote, 3000)
    }

    processCreditNotes = () => {
        if (this.state.selectedDist.length !== 0) {
            if (this.state.selectedDist[0].dseClientUpdate != 'pending') {
                this.setState({ loaderStatus: true })
                this.props.processCreditNoteWholeSale(this.state.selectedDist, {
                    onSuccess: () => {

                        apiTimeout = setTimeout(this.loadProcessCreditNote, 3000)
                    },
                    onFailure: () => {
                    }
                })
            }
            else {
                alert("DSE File Process Not Yet Done")
            }
        }
        else {
            alert('Please Select Distributor')
        }
    }

    loadReleaseCreditNote = () => {
        this.props.getWholesaleWokingReleaseProcessStatus(this.state.templateId, {
            onSuccess: (res) => {
                if (res.result.creditNoteRelease) {
                    if (res.result.creditNoteRelease == 'Completed') {
                        // this.setState({ loaderStatus:false})
                        clearTimeout(apiTimeout)
                        alert('Credit Note Released Successfully')
                        this.props.getwholesalesplittedFiles(this.state.templateId, {
                            onSuccess: (res) => {
                                this.setState({ splittedFiles: res.splittedFiles, loaderStatus: false })
                                // alert('Credit Note Process Done')
                            },
                            onFailure: () => {

                            }
                        })
                    }
                }
            },
            onFailure: () => {

            }
        })
        apiTimeout = setTimeout(this.loadReleaseCreditNote, 3000)
    }

    releaseCreditNote = () => {
        if (Object.keys(this.state.selectedDist).length !== 0) {
            if (this.state.selectedDist.creditNoteStatus != 'pending') {
                this.setState({ loaderStatus: true })
                this.props.sendWholesaleCreditNoteFiles(this.state.selectedDist, {
                    onSuccess: () => {
                        apiTimeout = setTimeout(this.loadReleaseCreditNote, 3000)
                    },
                    onFailure: () => {

                    }
                })
            }
            else {

            }

        }
        else {
            alert('Please Select Distributor')
        }
    }

    downloadApprovalEmails = () => {
        let data = {
            templateId: this.state.templateId,
            fileName: 'wholesale-approvalEmails'
        }
        this.props.getApprovedEmails(data, {
            onSuccess: (res) => {
                if (res.approvalData.length > 0) {
                    this.setState({ approvedEmailData: res.approvalData[0].result, approvalModalOpen: true })
                }
                else {
                    alert('No Data Found')
                }
            },
            onFailure: () => {

            }
        })
        // this.setState({approvalModalOpen:true})
    }

    closeFormulaModal = () => {
        this.setState({ formulaModalOpen: false, approvalModalOpen: false, releaseAlertMoalOpen: false, creditNoteReleaseAlertModalOpen: false })
    }

    showReleaseConfirmationAlert = () => {
        if (this.state.selectedDist.length) {
            this.setState({ releaseAlertMoalOpen: true })
        }
        else {
            alert('Please Select Distributor')
        }

    }

    showCreditNoteReleaseConfirmationAlert = () => {
        if (this.state.selectedDist.length) {
            this.setState({ creditNoteReleaseAlertModalOpen: true })
        }
        else {
            alert('Please Select Distributor')
        }

    }

    downloadDseDetails = () => {
        this.setState({ loaderStatus: true })
        this.props.downloadallDSEfiles(this.state.templateId, 'wholesaleDSE', {
            onSuccess: () => {
                this.setState({ loaderStatus: false })
            },
            onFailure: () => {
                this.setState({ loaderStatus: false })
            }
        })
    }

    downloadCreditNoteDetails = () => {
        this.setState({ loaderStatus: true })
        this.props.downloadallCreditNotefiles(this.state.templateId, 'wholesaleCreditNote', {
            onSuccess: () => {
                this.setState({ loaderStatus: false })
            },
            onFailure: () => {
                this.setState({ loaderStatus: false })
            }
        })
    }

    sendEmailforApproval = () => {
        this.setState({ loaderStatus: true })
        let data = {
            templateId: this.state.templateId,
            disType: "wholesale"
        }
        this.props.sendApprovalEmailToPandG(data, {
            onSuccess: (res) => {
                alert(res.status)
                this.setState({ loaderStatus: false })
            },
            onFailure: (res) => {
                alert(res.status)
                this.setState({ loaderStatus: false })
            }
        })
    }



    render() {

        var templateMonths = []

        this.state.templates.map((d) => {
            templateMonths.push({
                'key': d._id,
                'value': d.name,
                'text': d.name
            })
        })

        var overallLocationsData = []

        if (this.state.locationList.length > 0) {
            this.state.locationList.map((loc) => {
                overallLocationsData.push(
                    {
                        'key': loc.location,
                        'value': loc.location,
                        'text': loc.location
                    }
                )
            })
        }


        const auditing_split_columns = [
            {
                Header: "Site Name",
                accessor: "siteName",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <span>{original.siteName}</span>;
                },
            },
            {
                Header: "Location",
                accessor: "location",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <span>{original.location}</span>;
                },
            },
            {
                Header: "WholeSale Working",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <Icon name="arrow circle down" style={{ marginLeft: 45, cursor: 'pointer' }} color={'green'}
                        onClick={() => this.downloadfile( original.fileUrl)}
                    />;
                },
            },
           
            {
                Header: "Credit Note",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <Icon name="arrow circle down"
                        disabled={original.creditNoteStatus == 'pending' ? true : false}
                        style={{ marginLeft: 45, cursor: 'pointer' }} color={'green'}
                        onClick={() => this.downloadfile(original.creditNoteUrl)}
                    />;
                },
            },
            {
                Header: "Files Release Status",
                accessor: "workingReleaseCheck",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <h4>{original.workingReleaseCheck && original.workingReleaseCheck == 'Completed' ? 'Completed' : "Pending"}</h4>;
                },
            },
            {
                Header: "Files Release Date",

                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <h4>{original.releasingDate}</h4>;
                },
            },
            {
                Header: "Working Amount",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <h4>{original.working_count && original.working_count != undefined ? original.working_count : '-'}</h4>;
                },
            },
            {
                Header: "Credit Amount",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <h4>{original.credit_count && original.credit_count != undefined ? original.credit_count : "-"}</h4>;
                },
            },
        ];


        return (
            <div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <Dimmer active={this.state.loaderStatus}>
                        <Loader size="massive">File Processing.....</Loader>
                    </Dimmer>
                </div>

                {/* <br /> */}
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ marginLeft: 10 }}>
                        <Dropdown placeholder='Select Template Month' search selection options={templateMonths}
                            onChange={this.dropDownTemplateOnChange}
                            value={this.state.selectedTemplate}
                        />
                    </div>
                    <div style={{ marginLeft: 20 }}>
                        <Button color='blue'
                            onClick={() => this.periodSelect()}
                        >
                            <Icon name="calendar" />
                            Period of Sales
                        </Button>
                    </div>
                    <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, cursor: 'pointer' }}
                            size="large"
                            color="blue"
                            onClick={() => this.uploadFile('wholesale-approvalEmails', 'wholesale-approvalEmails')}
                        >

                            Upload P&G Approval Emails
                            <Icon name="upload" style={{ marginLeft: 10 }} />
                        </Label>
                    </div>
                    <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, cursor: 'pointer' }}
                            size="large"
                            color="blue"
                            onClick={() => this.downloadApprovalEmails()}
                        >

                            Download P&G Approval Emails
                            <Icon name="download" style={{ marginLeft: 10 }} />
                        </Label>
                    </div>



                </div>
                <div style={{ display: 'flex', flexDirection: 'row', marginTop: 20 }}>
                    <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, cursor: 'pointer' }}
                            size="large"
                            color="blue"
                            onClick={() => this.uploadFile('wholesale-approvedFiles', 'wholesale-approvedFiles')}
                        >

                            Upload Files for P&G Approval
                            <Icon name="upload" style={{ marginLeft: 10 }} />
                        </Label>
                    </div>

                    <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, cursor: 'pointer' }}
                            size="large"
                            color="blue"
                            onClick={() => this.sendEmailforApproval()}
                        >

                            Send Email for P&G Approval
                            <Icon name="envelope" style={{ marginLeft: 10 }} />
                        </Label>
                    </div>
                    <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, cursor: 'pointer' }}
                            size="large"
                            color="blue"
                            onClick={() => this.uploadFile('wsPgTargetData', 'wsPgTargetData')}
                        >

                            P&G Target Data
                            <Icon name="upload" style={{ marginLeft: 10 }} />
                        </Label>
                    </div>
                    <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, cursor: 'pointer' }}
                            size="large"
                            color="blue"
                            onClick={() => this.state.wsPgTargetDataUrl != '' ? this.downloadfile( this.state.wsPgTargetDataUrl) : alert('Data Not Found for Selected Month')}
                        >

                            P&G Target Data
                            <Icon name="download" style={{ marginLeft: 10 }} />
                        </Label>
                    </div>
                </div>


                <Grid columns={3} style={{ marginTop: 20 }}>

                    <GridColumn>
                        <Card.Group>
                            <h2 style={{ marginLeft: 10 }}>Final Disbursement Processing</h2>
                            <Card className="fluid" style={{ height: 200 }}>
                                <Card.Content>
                                    <Image
                                        floated='right'
                                        size='mini'
                                        src={processIcon}
                                        style={{ cursor: 'pointer' }}
                                    />
                                    <Card.Description>
                                        <h4>{`Automation Status   `}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: <strong style={{ color: this.state.automationStatus == 'Completed' ? 'green' : this.state.automationStatus == 'Processing' ? 'orange' : 'red' }}>{this.state.automationStatus}</strong></h4>
                                    </Card.Description>
                                    <br></br>

                                </Card.Content>
                                <Card.Content extra>

                                    <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                                        {this.state.initial == true && (
                                            <Button basic color='green'
                                                onClick={() => this.start()}
                                            >
                                                <Icon name="hand point up" />
                                                Start
                                            </Button>
                                        )}
                                        {this.state.initial == false && (
                                            <Button basic color='orange'
                                                onClick={() => this.start()}
                                            >
                                                <Icon name="redo" />
                                                Re-Start
                                            </Button>
                                        )}
                                        {this.state.initial == false && (
                                            <Button basic color='green'
                                                onClick={() => this.downloadfile(this.state.outputUrl)}
                                                disabled={this.state.downloadEnable == true ? false : true}
                                            >
                                                <Icon name="download" />
                                                Download
                                            </Button>
                                        )}

                                    </div>

                                </Card.Content>
                            </Card>

                        </Card.Group>
                    </GridColumn>
                    <GridColumn style={{ display: 'flex', flexDirection: 'row' }}>
                        <Card.Group>
                            <h2>Automation Result</h2>
                            <Card className="fluid" style={{ height: 200 }}>
                                <Card.Content>
                                    <Image
                                        floated='right'
                                        size='mini'
                                        src={excel}
                                        style={{ cursor: 'pointer' }}
                                    />
                                    <br></br>
                                    <br></br>
                                    <br></br>
                                    <Card.Description style={{ marginTop: 20 }}>
                                        <h3 style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>{`Automation File  `}
                                            <Icon name="arrow circle down" style={{ marginLeft: 75, cursor: 'pointer' }} color={'green'}
                                                disabled={this.state.downloadEnable == true ? false : true}
                                                onClick={() => this.downloadfile( this.state.outputUrl)}
                                            />
                                            <Icon name="pencil alternate" style={{ cursor: 'pointer' }} color={'green'}
                                                onClick={() => this.formulasModal('')}
                                            />
                                        </h3>
                                    </Card.Description>

                                    <br></br>

                                </Card.Content>
                            </Card>
                        </Card.Group>
                        <br></br>

                    </GridColumn>
                    <GridColumn>
                        <Card.Group>
                            <h2>Approved Disbursement</h2>
                            <Card className="fluid" style={{ height: 200 }}>
                                <Card.Content>
                                    <Image
                                        floated='right'
                                        size='mini'
                                        src={excel}
                                        style={{ cursor: 'pointer' }}
                                    />
                                    <br></br>
                                    <br></br>
                                    <br></br>
                                    <Card.Description style={{ marginTop: 20 }}>
                                        <h3 style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>{'Approved File   '} <Icon name="upload" style={{ marginLeft: 65, cursor: 'pointer' }} color={'orange'}
                                            onClick={() => this.uploadFile('wholesaleDisbursement', 'wholesaleDisbursement')}
                                        /><Icon name="arrow circle down" style={{ marginLeft: 25, cursor: 'pointer' }} color={'green'}
                                            onClick={() => this.downloadfile(this.state.workingFiles[0].result[0])}
                                            /></h3>

                                    </Card.Description>

                                    <br></br>

                                </Card.Content>
                            </Card>
                        </Card.Group>
                    </GridColumn>
                </Grid>
                <br></br>
                <br></br>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div>
                        <p style={{ fontSize: 25 }}>
                            <h1
                                style={{

                                    flex: "0 0 30px",
                                    display: "inline-block",
                                    color: "#2185d0",
                                }}
                            >
                                Disbursement Working for Sites
                            </h1>
                        </p>
                    </div>

                    <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, marginTop: 5, cursor: 'pointer' }}
                            size="large"
                            color="blue"
                            onClick={() => this.splitFiles()}
                            disabled={true}
                        >

                            Split Files
                            <Icon name="file" style={{ marginLeft: 10 }} />
                        </Label>
                    </div>
                    {/* <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, marginTop: 5, cursor: 'pointer' }}
                            size="large"
                            color="blue"
                            onClick={() => this.showReleaseConfirmationAlert()}
                            disabled={true}
                        >

                            Release Workings
                            <Icon name="envelope" style={{ marginLeft: 10 }} />
                        </Label>
                    </div>
                    <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, marginTop: 5, cursor: 'pointer' }}
                            size="large"
                            color="blue"
                            onClick={() => this.processCreditNotes()}
                            disabled={true}
                        >

                            Process CreditNote
                            <Icon name="file" style={{ marginLeft: 10 }} />
                        </Label>
                    </div> */}
                    <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, marginTop: 5, cursor: 'pointer' }}
                            size="large"
                            color="blue"
                            onClick={() => this.showReleaseConfirmationAlert()}
                            disabled={true}
                        >

                            Release Workings & CreditNote
                            <Icon name="envelope" style={{ marginLeft: 10 }} />
                        </Label>
                    </div>
                    {/* <div>
                                            <Label
                                                style={{ justifyContent: 'flex-end',marginLeft: 10,marginTop: 5, cursor: 'pointer' }}
                                                size="large"
                                                color="blue"
                                                onClick={() => this.downloadDseDetails()}
                                                disabled={true}
                                            >
                    
                                                 DSE
                                                <Icon name="download" style={{ marginLeft: 10 }} />
                                            </Label>
                                        </div> */}
                    <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 10, marginTop: 5, cursor: 'pointer' }}
                            size="large"
                            color="blue"
                            onClick={() => this.downloadCreditNoteDetails()}
                            disabled={true}
                        >

                            Credit Note
                            <Icon name="download" style={{ marginLeft: 10 }} />
                        </Label>
                    </div>

                </div>


                <p style={{ fontSize: 18 }}>
                    <h1
                        style={{

                            flex: "0 0 30px",
                            display: "inline-block",
                            color: "#0000000",
                        }}
                    >
                        Site Wise Files
                    </h1>
                </p>
                <CheckboxTable
                    data={this.state.splittedFiles}
                    columns={auditing_split_columns}
                    sendedData={this.siteData}
                />
                <br></br>
                <br></br>

                <Modal
                    open={this.state.periodModalOpen}
                    onClose={this.closeuploadoption}
                    size="normal"
                >
                    <Modal.Content>
                        <Form>
                            <h3><strong>{`Select a PSR sales date for each location.`}</strong></h3>
                            {console.log(this.state.locationList, 'locationList')}



                            {this.state.locationList.length > 0 && this.state.locationList.map((loc) => {
                                // console.log(this.state.locationList, 'locationList')
                                return (

                                    <Grid columns={3}>
                                        <Grid.Row>
                                            <Grid.Column>
                                                <Form.Input
                                                    type="any"
                                                    value={loc.location}
                                                    placeholder=""
                                                    editable={false}
                                                />
                                            </Grid.Column>
                                            <Grid.Column>
                                                <Form.Input
                                                    type="any"
                                                    value={loc.startDate}
                                                    placeholder=""
                                                    onChange={(e) => this.handleStartDateChange(e, loc)}
                                                />
                                            </Grid.Column>
                                            <Grid.Column>
                                                <Form.Input
                                                    type="any"
                                                    value={loc.endDate}
                                                    placeholder=""
                                                    onChange={(e) => this.handleEndDateChange(e, loc)}
                                                />
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>

                                )
                            })}



                        </Form>
                    </Modal.Content>

                    <Modal.Actions>
                        <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
                            <ButtonHandler
                                click={this.savePeriodsData}
                                title={'Save'}
                                color={'green'}
                                iconColor={'white'}
                            />
                            <ButtonHandler
                                click={this.closeuploadoption}
                                isIcon={true}
                                color={'red'}
                                iconName={'remove'}
                                iconColor={'white'}
                                title={'Close'}
                            />
                        </div>

                    </Modal.Actions>
                    {this.state.loaderStatus && (
                        <Dimmer active inverted>
                            <Loader inverted>Loading</Loader>
                        </Dimmer>
                    )}
                </Modal>
                <Modal
                    open={this.state.formulaModalOpen}
                    onClose={this.closeFormulaModal}
                    size="normal"
                >
                    <Modal.Content>
                        <Form>
                            <strong>{`IF No formula for a column please specifiy the column as like "A -- No Formula"`}</strong>
                            {this.state.formulas.length > 0 && this.state.formulas.map((d) => {
                                return (
                                    <Grid columns={1}>
                                        <Grid.Row>
                                            <GridColumn style={{ marginTop: 20 }}>
                                                <Form.Input
                                                    type="any"
                                                    label={Object.keys(d)[0]}
                                                    value={Object.values(d)[0]}
                                                    onChange={(e) => this.formulaOnChange(e, d)}
                                                    placeholder={Object.values(d)[0]}
                                                />
                                            </GridColumn>
                                        </Grid.Row>
                                    </Grid>
                                )

                            })}



                        </Form>
                    </Modal.Content>

                    <Modal.Actions>
                        <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
                            <ButtonHandler
                                click={this.saveFormulas}
                                title={'Save'}
                                color={'green'}
                                iconColor={'white'}
                            />
                            <ButtonHandler
                                click={this.closeFormulaModal}
                                isIcon={true}
                                color={'red'}
                                iconName={'remove'}
                                iconColor={'white'}
                                title={'Close'}
                            />
                        </div>

                    </Modal.Actions>
                </Modal>
                <Modal
                    open={this.state.modalOpen}
                    onClose={this.closeuploadoption}
                    size="mini"
                >
                    <Modal.Content>
                        <Form>
                            <Grid columns={1}>
                                <Grid.Row>

                                    <Grid.Column style={{ marginTop: 20 }}>
                                        <h4>Upload Master data :</h4>
                                        <Input
                                            type="file"
                                            accept=".xlsx"
                                            onChange={this.fileupload}
                                            multiple
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Form>
                    </Modal.Content>

                    <Modal.Actions>
                        <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
                            <ButtonHandler
                                click={this.uploadRawFile}
                                title={'Upload'}
                                color={'green'}
                                iconColor={'white'}
                                disabled={this.state.fileUploaded == true ? false : true}
                            />
                            <ButtonHandler
                                click={this.closeuploadoption}
                                isIcon={true}
                                color={'red'}
                                iconName={'remove'}
                                iconColor={'white'}
                                title={'Close'}
                            />
                        </div>

                    </Modal.Actions>
                    {this.state.loaderStatus && (
                        <Dimmer active inverted>
                            <Loader inverted>Loading</Loader>
                        </Dimmer>
                    )}
                </Modal>
                <Modal
                    open={this.state.approvalModalOpen}
                    onClose={this.closeFormulaModal}
                    size="normal"
                >
                    <Modal.Content>
                        <Form>
                            {this.state.approvedEmailData.length > 0 && this.state.approvedEmailData.map((d) => {
                                return (
                                    <>
                                        <h3>{d.fileName} :  <Icon name="arrow circle down" style={{ marginLeft: 25, cursor: 'pointer' }} color='green' onClick={() => this.downloadfile(d.fileUrl)} /></h3>
                                    </>
                                )
                            })}



                        </Form>
                    </Modal.Content>

                    <Modal.Actions>
                        <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>

                            <ButtonHandler
                                click={this.closeuploadoption}
                                isIcon={true}
                                color={'red'}
                                iconName={'remove'}
                                iconColor={'white'}
                                title={'Close'}
                            />
                        </div>

                    </Modal.Actions>
                </Modal>
                <Modal
                    open={this.state.releaseAlertMoalOpen}
                    onClose={this.closeFormulaModal}
                    size="normal"
                >
                    <Modal.Content>
                        <Form>
                            <h1><b>Below Sites You're Choosing for Working Files Release Process </b></h1>
                            {this.state.selectedDist.length > 0 && this.state.selectedDist.map((d, index) => {
                                return (
                                    <>
                                        <h3>{index + 1}{'. '}{d.siteName}-{d.location}</h3>
                                    </>
                                )
                            })}
                        </Form>
                    </Modal.Content>

                    <Modal.Actions>
                        <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
                            <ButtonHandler
                                click={this.releaseWorking}
                                isIcon={true}
                                color={'green'}
                                iconName={'mail'}
                                iconColor={'white'}
                                title={'Send'}
                            />
                            <ButtonHandler
                                click={this.closeFormulaModal}
                                isIcon={true}
                                color={'red'}
                                iconName={'remove'}
                                iconColor={'white'}
                                title={'Close'}
                            />
                        </div>

                    </Modal.Actions>
                    {this.state.loaderStatus && (
                        <Dimmer active inverted>
                            <Loader inverted>Loading</Loader>
                        </Dimmer>
                    )}
                </Modal>
                <Modal
                    open={this.state.creditNoteReleaseAlertModalOpen}
                    onClose={this.closeFormulaModal}
                    size="normal"
                >
                    <Modal.Content>
                        <Form>
                            <h1><b>Below Sites You're Choosing for Credit Note Release Process </b></h1>
                            {this.state.selectedDist.length > 0 && this.state.selectedDist.map((d, index) => {
                                return (
                                    <>
                                        <h3>{index + 1}{'. '}{d.siteName}-{d.location}</h3>
                                    </>
                                )
                            })}
                        </Form>
                    </Modal.Content>

                    <Modal.Actions>
                        <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
                            <ButtonHandler
                                click={this.releaseCreditNote}
                                isIcon={true}
                                color={'green'}
                                iconName={'mail'}
                                iconColor={'white'}
                                title={'Send'}
                            />
                            <ButtonHandler
                                click={this.closeFormulaModal}
                                isIcon={true}
                                color={'red'}
                                iconName={'remove'}
                                iconColor={'white'}
                                title={'Close'}
                            />
                        </div>

                    </Modal.Actions>
                    {this.state.loaderStatus && (
                        <Dimmer active inverted>
                            <Loader inverted>Loading</Loader>
                        </Dimmer>
                    )}
                </Modal>
            </div>

        )

    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        user: state.user,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            runWholeSaleAutomationScript,
            getWholeSaleAutomationScriptStatus,
            fetchTemplates,
            fetchUseraction,
            rawFileProcess,
            getWorkingFiles,
            getWholeSaleLocationsData,
            addWholeSalePeriodsData,
            getWholeSalePeriodsData,
            wholesaleSplitFiles,
            getwholesalesplitStatus,
            getwholesalesplittedFiles,
            processCreditNoteWholeSale,
            getWholesalDisbursementFormulas,
            wholesaleIpdateDisbursementFormulas,
            sendWholesaleWorkingFiles,
            sendWholesaleCreditNoteFiles,
            getApprovedEmails,
            getWholesaleWokingReleaseProcessStatus,
            downloadallDSEfiles,
            downloadallCreditNotefiles,
            sendApprovalEmailToPandG,
            getPlanData
        },
        dispatch
    );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Wholesale));
